import React from 'react';

import ReportController from '../../Components/ReportController';
import ReportDisplay from '../../Components/ReportDisplay';
import ExportContainer from '../../Components/ExportContainer';
import { ReportControlBar } from '../../Components/ReportControlBar';
import { Button } from '../../../../components/Button';

import ReportBuilder from './builder';

const { FEATURE_REPORTS_NAVBAR_UI } = process.env;
class AuthoringStatus extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.setJurisdiction = this.setJurisdiction.bind(this);
        this.stepBack = this.stepBack.bind(this);
        this.exportRef = React.createRef();

        this.defaultReportContext = {
            type: 'authoring-status',
            jurisdictionContext: null,
            condition: null,
            jurisdiction: null,
            userType: null,
            complete: false,
            loading: false
        };

        this.state = {
            reportContext: this.defaultReportContext,
            displayState: 0
        };
    }

    componentDidMount() {
        if (this.props.userContext.jurisdictionId !== null) {
            let jurisdictionLabel = this.props.dataContext.jurisdiction[this.props.userContext.jurisdictionId];
            this.setJurisdiction({
                label: jurisdictionLabel,
                value: this.props.userContext.jurisdictionId
            });
        }
    }

    setJurisdiction(val) {
        if (val === null) {
            this.setState({
                reportContext: {
                    ...this.state.reportContext,
                    ...{
                        jurisdiction: val,
                        complete: false,
                        loading: false
                    }
                }
            });
        } else {
            this.setState(
                {
                    reportContext: {
                        ...this.state.reportContext,
                        ...{
                            jurisdiction: val,
                            loading: true,
                            complete: true
                        }
                    }
                },
                () => {
                    this.buildReport();
                }
            );
        }
    }

    buildReportContext() {
        let outputArray = [];
        outputArray.push(<div key={`context-${outputArray.length}`}>Selected Report Type: Authoring Status</div>);

        return outputArray;
    }

    async buildReport() {
        let reportData = await this.props.fetchReportData('authoringStatus', this.state.reportContext);
        let report = ReportBuilder(reportData).build();

        this.setState({
            reportContext: {
                ...this.state.reportContext,
                ...{ loading: false, complete: true, sections: report }
            }
        });
        /*
        window.dataLayer.push({
            event: 'reports_buildReport',
            rckmsEventCategory: `Reports`,
            rckmsEventAction: `Generated Authoring Status`,
            rckmsEventLabel: `${this.state.reportContext.jurisdiction.label}`
        });
        */
    }

    async downloadExcelReport() {
        this.props.handleReportPathSelect('authoring-status-excel', this.state.reportContext);
    }

    stepBack() {
        if (this.state.displayState === 1) {
            this.setState({ displayState: 0 });
        } else {
            this.props.back();
        }
    }

    render() {
        let actions =
            FEATURE_REPORTS_NAVBAR_UI !== 'true'
                ? [
                      {
                          label: 'Back',
                          display: true,
                          action: this.stepBack
                      },
                      {
                          label: 'Export Report',
                          display: this.state.reportContext.complete && !this.state.reportContext.loading,
                          action: () => {
                              this.setState({ displayState: 1 });
                          }
                      }
                  ]
                : [];
        const isAdmin =
            typeof this.props.userContext == 'object' &&
            ['JURISDICTION_ADMINISTRATOR', 'RCKMS_ADMINISTRATOR'].includes(this.props.userContext.role);
        let selectOptions = { ...this.props.dataContext.jurisdiction };
        delete selectOptions.default;

        if (this.props.userContext.jurisdictionId) {
            selectOptions = {
                [this.props.userContext.jurisdictionId]: this.props.dataContext.jurisdiction[
                    this.props.userContext.jurisdictionId
                ]
            };
        }

        return (
            <div className="authoring-status-container">
                {FEATURE_REPORTS_NAVBAR_UI === 'true' ? (
                    <ReportControlBar onBack={this.stepBack}>
                        {this.state.reportContext.complete && !this.state.reportContext.loading ? (
                            <>
                                {this.state.displayState === 0 ? (
                                    <Button
                                        onClick={() => {
                                            this.setState({ displayState: 1 });
                                        }}
                                        hasIcon
                                        iconPosition={'left'}
                                        icon={`ios_share`}
                                    >
                                        Export
                                    </Button>
                                ) : null}
                                {this.state.displayState === 1 ? (
                                    <>
                                        <Button
                                            onClick={() => {
                                                this.exportRef?.current?.print?.();
                                            }}
                                            hasIcon
                                            iconPosition={'left'}
                                            icon={`print`}
                                        >
                                            Print
                                        </Button>
                                        <Button
                                            hasIcon
                                            iconPosition={'left'}
                                            icon={`file_download`}
                                            onClick={() => {
                                                this.downloadExcelReport();
                                            }}
                                        >
                                            Download .xlsx
                                        </Button>
                                    </>
                                ) : null}
                            </>
                        ) : null}
                    </ReportControlBar>
                ) : null}
                {this.state.displayState === 0 ? (
                    <>
                        <div className="one-third">
                            <ReportController
                                user={this.props.userContext}
                                reportContext={this.state.reportContext}
                                stepLabel={'Select a Jurisdiction'}
                                actions={actions}
                                onChange={this.setJurisdiction}
                                value={this.state.reportContext.jurisdiction}
                                selectOptions={selectOptions}
                                displayContext={this.buildReportContext()}
                                isFixedOpen={FEATURE_REPORTS_NAVBAR_UI !== 'true'}
                            />
                        </div>
                        <div className="two-thirds">
                            {this.state.reportContext.complete && (
                                <ReportDisplay
                                    title="Authoring Status Report"
                                    jurisdiction={this.state.reportContext.jurisdiction.label}
                                    loading={this.state.reportContext.loading}
                                    reportSections={this.state.reportContext.sections}
                                />
                            )}
                        </div>
                    </>
                ) : null}
                {this.state.displayState === 1 ? (
                    <>
                        <ExportContainer
                            ref={this.exportRef}
                            title="Authoring Status"
                            jurisdiction={this.state.reportContext.jurisdiction.label}
                            condition={null}
                            back={() => {
                                this.setState({ displayState: 0 });
                            }}
                            sections={this.state.reportContext.sections}
                        />
                    </>
                ) : null}
            </div>
        );
    }
}

export default AuthoringStatus;
